var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 61,
    viewBox: "0 0 73 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_2745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6578 0.796875C17.3226 0.796875 2.17439 25.3969 0.74115 46.1743C6.80876 56.7048 21.4406 60.6631 36.6583 60.6631C51.875 60.6631 66.5076 56.7048 72.5721 46.1741C71.1386 25.3969 55.9924 0.796875 36.658 0.796875",
    fill: "#B6DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5196 41.2251C67.5196 41.2251 63.2492 31.9924 58.9086 26.6059C54.5649 21.2172 49.2604 15.3496 46.1241 15.3496C42.9894 15.3496 34.2266 30.8645 30.2066 30.8645C26.1858 30.8645 24.0962 23.8313 19.1528 23.8313C14.2075 23.8313 6.35057 40.7916 6.35057 40.7916L5.81818 43.6668C5.81818 43.6668 8.54775 55.7685 37.1038 55.7685C65.661 55.7685 67.9432 43.8654 67.9432 43.8654L67.5199 41.2248",
    fill: "#66CC66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6542 37.4855C26.2192 37.4855 23.9457 33.1097 22.7131 30.4086C21.6046 27.9753 21.4128 24.1336 18.2677 24.026C18.5767 23.9035 18.8742 23.8311 19.1531 23.8311C24.0964 23.8311 26.186 30.8643 30.2069 30.8643C34.2269 30.8643 42.9897 15.3491 46.1243 15.3491C46.715 15.3491 47.3804 15.5576 48.1023 15.9283C47.5683 15.8579 46.8835 15.9069 46.3559 16.4362C45.3426 17.4497 36.1446 37.4855 30.6542 37.4855Z",
    fill: "#17AD49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_2745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.1127,
    height: 60,
    fill: "white",
    transform: "translate(0.516846 0.796875)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo4);
export default __webpack_public_path__ + "static/media/logo4.b37acb55e3e6f78922d0c0a0d51d148d.svg";
export { ForwardRef as ReactComponent };